/**
 * Usage:
 * [server response]
 * {
 *   data: {
 *     data: 'Hello World'
 *   }
 * }
 *
 * await request.thenData() => 'Hello world!'
 */
Promise.prototype.thenData = function() {
    return this.then(response => response.data.data)
}
